import React from "react";
import { notification } from "antd";
import { parseValidationErrorMessage } from "helpers/generalHelper";
import ValidationErrorToastContent from "components/Common/ValidationErrorToastContent";

/**
 * Shows a toast with validation errors in a structured format.
 * If the message matches "Option #N: Type: Error; ..." it will be parsed and
 * displayed as Option #N, type, and bullet list of errors. Otherwise the raw
 * message is shown. Use anywhere (CSV import, bulk actions, etc.).
 *
 * @param {string} message - Raw error message from API
 * @param {object} options - Optional
 * @param {string} options.title - Notification title (default: "Validation failed")
 * @param {number} options.duration - Seconds to show (0 = no auto close; default: 0 for formatted, 6 for raw)
 * @param {string} options.placement - topRight, topLeft, etc. (default: "topRight")
 * @param {"error"|"warning"} options.variant - "error" (red) or "warning" (yellow); default "error"
 */
export const toastValidationErrors = (
  message,
  options = {}
) => {
  const {
    title = "Validation Errors",
    duration,
    placement = "topRight",
    variant = "error",
  } = options;

  const parsed = parseValidationErrorMessage(message);
  const hasStructured = parsed.length > 0;
  const isWarning = variant === "warning";
  const notify = isWarning ? notification.warning : notification.error;

  if (hasStructured) {
    notify({
      message: title,
      description: <ValidationErrorToastContent items={parsed} variant={variant} />,
      placement,
      duration: duration !== undefined ? duration : 0,
      style: { width: 420 },
    });
  } else {
    notify({
      message: title,
      description: message,
      placement,
      duration: duration !== undefined ? duration : 6,
    });
  }
};
